





































































































































































































































































































































































import BaseComponent from '@/core/base.component';
import { Component, Vue } from 'vue-property-decorator';
import CodeManagementService from '../../../services/code-management.service';
import PresentationEventService from '@/services/presentation-event.service';
import { PresentationEventDto, PresentationEventListDto } from '@/dto';
import FileUploadService, {
  UPLOAD_TYPE,
} from '@/services/shared/file-upload/file-upload.service';
import {
  ATTACHMENT_REASON_TYPE,
  FileAttachmentDto,
} from '@/services/shared/file-upload';
import { Pagination } from '@/common';
import { CodeManagementDto } from '@/services/init/dto';
import toast from '../../../../resources/assets/js/services/toast.js';
import {
  ClearOutQueryParamMapper,
  ReverseQueryParamMapper,
  RouterQueryParamMapper,
} from '@/core';

@Component({
  name: 'PresentationEventList',
})
export default class PresentationEventList extends BaseComponent {
  private presentationEventList: PresentationEventDto[] = [];
  private presentationEventTotalCount = null;
  private presentationEventSearchDto = new PresentationEventListDto();
  private presentationEventCreateDto = new PresentationEventDto();
  private attachments: FileAttachmentDto[] = [];
  private mobileAttachments: FileAttachmentDto[] = [];
  private dataLoading = false;
  private pagination = new Pagination();
  private displayTypeSelect: CodeManagementDto[] = [];
  private eventTypeSelect: CodeManagementDto[] = [];
  private scheduleList = ['11시 오전', '2시 오후'];
  private imageChanged = false;
  private mobieImageChanged = false;

  // 이미지 업로드
  async uploadMainImage(file: File) {
    const attachments = await FileUploadService.upload(
      UPLOAD_TYPE.PRESENTATION_EVENT,
      [file],
    );
    this.attachments = [];
    this.attachments.push(
      ...attachments.filter(
        fileUpload =>
          fileUpload.attachmentReasonType === ATTACHMENT_REASON_TYPE.SUCCESS,
      ),
    );
    this.imageChanged = true;
  }

  removeImage() {
    this.attachments = [];
    this.$refs['fileInput'].reset();
    this.imageChanged = false;
  }

  async uploadMobileImage(file: File) {
    const attachments = await FileUploadService.upload(
      UPLOAD_TYPE.PRESENTATION_EVENT,
      [file],
    );
    this.mobileAttachments = [];
    this.mobileAttachments.push(
      ...attachments.filter(
        fileUpload =>
          fileUpload.attachmentReasonType === ATTACHMENT_REASON_TYPE.SUCCESS,
      ),
    );
    this.mobieImageChanged = true;
  }

  removeMobileImage() {
    this.mobileAttachments = [];
    this.$refs['fileInputMobile'].reset();
    this.mobieImageChanged = false;
  }

  findOne(id) {
    this.$router.push(`/presentation-event/${id}`);
  }

  findAll(isPagination?: boolean, isSearch?: boolean) {
    this.dataLoading = true;
    if (!isPagination) {
      this.pagination.page = 1;
    } else {
      if (isSearch) this.pagination.page = 1;
      RouterQueryParamMapper(this.presentationEventSearchDto, this.pagination);
    }
    PresentationEventService.findAll(
      this.presentationEventSearchDto,
      this.pagination,
    ).subscribe(res => {
      if (res) {
        this.dataLoading = false;
        this.presentationEventList = res.data.items;
        this.presentationEventTotalCount = res.data.totalCount;
      }
    });
  }

  paginateSearch() {
    this.findAll(true);
  }

  search() {
    this.findAll(true, true);
  }

  clearOut() {
    if (location.search) {
      ClearOutQueryParamMapper();
    } else {
      this.presentationEventSearchDto = new PresentationEventListDto();
      this.findAll();
    }
  }

  clearOutCreateDto() {
    this.attachments = [];
    this.mobileAttachments = [];
    this.presentationEventCreateDto = new PresentationEventDto();
  }

  createEvent() {
    if (this.attachments) {
      this.presentationEventCreateDto.image = this.attachments;
    } else {
      delete this.presentationEventCreateDto.image;
    }
    if (this.mobileAttachments) {
      this.presentationEventCreateDto.mobileImage = this.mobileAttachments;
    } else {
      delete this.presentationEventCreateDto.mobileImage;
    }
    PresentationEventService.create(this.presentationEventCreateDto).subscribe(
      res => {
        if (res) {
          toast.success('추가완료');
          this.clearOut();
        }
      },
    );
  }

  created() {
    const query = ReverseQueryParamMapper(location.search);
    if (query) {
      this.presentationEventSearchDto = query;
      if (!isNaN(+query.limit) && !isNaN(+query.page)) {
        this.pagination.limit = +query.limit;
        this.pagination.page = +query.page;
      } else {
        this.pagination = new Pagination();
      }
      this.paginateSearch();
    } else {
      this.findAll();
    }
    this.getCommonCodes('eventTypeSelect', 'PRESENTATION_EVENT_TYPE');
    this.getCommonCodes('displayTypeSelect', 'PRESENTATION_DISPLAY_TYPE');
  }
}
